export const GOOGLE_API_KEY = "AIzaSyCp3-fE66WbStPv4_SppaPB9GAjxHXxuDY";
